import { day, STATUS_STYLE } from "@/lib/money";

export default function CancelledList({ items }) {
  return (
    <section className="brutal-border p-4 sm:p-5 min-w-0" data-testid="revenue-cancelled">
      <div className="font-mono-label text-[10px] text-muted-foreground mb-3">CANCELLED / EXPIRED · {items.length}</div>
      {items.length === 0 && <p className="text-sm text-muted-foreground" data-testid="revenue-cancelled-empty">No cancelled or expiring subscriptions.</p>}
      <div className="divide-y divide-[#262626]">
        {items.map((x, i) => (
          <div key={`${x.user_id}-${i}`} className="py-2.5" data-testid={`revenue-cancelled-row-${i}`}>
            <div className="flex items-center justify-between gap-3">
              <div className="text-sm font-semibold truncate">{x.name || x.email}</div>
              <div className={`font-mono-label text-[10px] shrink-0 ${STATUS_STYLE[x.status] || ""}`}>{x.status === "canceling" ? "ENDS SOON" : x.status.replace("_", " ").toUpperCase()}</div>
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">
              {x.business ? `${x.business} · ` : ""}{x.plan} · {x.status === "canceling" ? `ends ${day(x.ends_at)}` : `cancelled ${day(x.canceled_at)}`}
              {x.reason ? ` · “${x.reason}”` : ""}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
